import type { Edge, EdgeId, Node, PromptData } from '@/types/node';

/**
 * IMPORTANT: This file contains logic for the migration logic in  FlowGraph.ts and will be moved soon to the backend.
 * Please do not use these functions in other places but FlowGraph.ts.
 */
export const migratePromptV2ToPromptV3 = (
  node: Node,
  removeEdges: (edgeIds: EdgeId[]) => void,
  getEdges: () => Edge[],
) => {
  node.type = 'promptV3';
  let data = node.data as PromptData;

  if (data.prompt === undefined) {
    const result = data.result as { prompt?: string } | undefined;
    const output = data.output as Record<string, any> | undefined;
    data = { ...data, prompt: result?.prompt ?? output?.['prompt'] ?? '' };
  }
  node.data = data;
  // remove negative handle if it exists
  if (Array.isArray(node.data.handles.output) && node.data.handles.output?.includes('negative_prompt')) {
    node.data.handles.output = node.data.handles.output.filter((handle) => handle !== 'negative_prompt');
  }
  // remove the edge if the source handle is 'negative_prompt' and it originates from this node
  const negativePromptEdges = getEdges().filter((edge) => {
    return edge.source === node.id && edge.sourceHandle?.includes('negative_prompt');
  });
  if (negativePromptEdges.length > 0) {
    removeEdges(negativePromptEdges.map((edge) => edge.id));
  }
};
